import React from "react";

const LuxuryAssetSkeleton = () => {
  return (
    <>
      <div className="space-y-5">
        <div className="flex items-baseline gap-16 justify-between w-fit">
          <div className="h-4 w-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex items-baseline gap-12 justify-between w-fit">
          <div className="h-4 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>
      <div className="space-y-5">
        <div className="flex items-baseline gap-12 justify-between w-fit">
          <div className="h-4 w-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex items-baseline gap-12 justify-between w-fit">
          <div className="h-4 w-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>
      <div className="space-y-5">
        <div className="flex items-baseline gap-16 justify-between w-fit">
          <div className="h-4 w-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex items-baseline gap-12 justify-between w-fit">
          <div className="h-4 w-20 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>
      <div className="space-y-5">
        <div className="flex items-baseline gap-12 justify-between w-fit">
          <div className="h-4 w-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
        <div className="flex items-baseline gap-12 justify-between w-fit">
          <div className="h-4 w-16 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-6 w-24 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>
    </>
  );
};

export default LuxuryAssetSkeleton;
